export default function addAnimationToHeader() {
  const header = document.querySelector(".js-header");

  if (!header) {
    return;
  }

  const headerLogo = document.querySelector(".js-header-logo");
  let bannerBlock = document.querySelector(".js-banner-block");
  let homepage = false;

  if (bannerBlock) {
    homepage = true;
  } else {
    bannerBlock = header.nextElementSibling;
    console.log(bannerBlock);
  }

  header.classList.remove("bg-opacity-75");
  header.classList.add("bg-opacity-0");

  if (homepage) {
    headerLogo.classList.add("sm:opacity-0");
  }

  const callback = function(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        header.classList.add("bg-opacity-75");
        header.classList.remove("bg-opacity-0", "h-0");

        if (homepage) {
          headerLogo.classList.add("motion-safe:animate-fadeIn");
          headerLogo.classList.remove("sm:opacity-0");
        }
      } else {
        header.classList.remove("bg-opacity-75");
        header.classList.add("h-0", "bg-opacity-0");

        if (homepage) {
          headerLogo.classList.add("sm:opacity-0");
          headerLogo.classList.remove("motion-safe:animate-fadeIn");
        }
      }
    });
  };

  const observer = new IntersectionObserver(callback);

  // Add the element to the watcher
  observer.observe(bannerBlock);
}
